import { render } from "./CopyLink.vue?vue&type=template&id=7c424f2d&scoped=true"
import script from "./CopyLink.vue?vue&type=script&lang=ts"
export * from "./CopyLink.vue?vue&type=script&lang=ts"

import "./CopyLink.vue?vue&type=style&index=0&id=7c424f2d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7c424f2d"

export default script